<template>
  <div class="contain">
    <!-- 검색 조건 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="{ tablet: 'top' }[$device.currentSize] ?? 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :sm="8">
            <el-form-item :label="$t('권한ID')">
              <el-input v-model="searchForm.authId" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item :label="$t('권한명')">
              <el-input v-model="searchForm.authNm" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼-->
    <div class="buttons" ref="buttons">
      <el-button v-if="checkAuthActionAccess('AuthSearch')" :size="size" @click="search" icon="el-icon-search">{{
        $t('검색')
      }}</el-button>
      <el-button
        v-if="checkAuthActionAccess('AuthAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('AuthUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('AuthDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('AuthAuth')"
        :size="size"
        @click="openAuth"
        icon="el-icon-setting"
        :disabled="btn.openAuthDisabled"
        >{{ $t('리소스 설정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('AuthAdd') || checkAuthActionAccess('AuthUp')"
        :size="size"
        @click="save"
        icon="el-icon-check"
        :disabled="btn.saveDisabled"
        style="float: right"
        class="hide-on-mobile"
        >{{ $t('저장') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-row :gutter="20">
      <el-col :md="12">
        <el-table
          :height="tableHeight"
          ref="table"
          border
          stripe
          highlight-current-row
          tooltip-effect="dark"
          :data="tableData"
          :size="size"
          :empty-text="$t('데이타 없음')"
          @row-click="handleRowClick"
          @select="handleRowChecked"
          @select-all="handleRowChecked">
          <el-table-column
            :label="tableData.length.toString()"
            type="index"
            width="55"
            align="center"
            sortable
            :fixed="!$device.mobile"
            label-class-name="data_cnt"></el-table-column>
          <el-table-column type="selection" width="45" align="center" :fixed="!$device.mobile"></el-table-column>
          <el-table-column
            :label="$t('권한ID')"
            prop="authId"
            width="180"
            align="center"
            :fixed="!$device.mobile"
            show-overflow-tooltip></el-table-column>
          <el-table-column
            :label="$t('권한명')"
            prop="authNm"
            min-width="200"
            sortable
            show-overflow-tooltip></el-table-column>
          <el-table-column
            :label="$t('사용 가능 여부')"
            prop="useYn"
            min-width="100"
            align="center"
            :formatter="mainVue.formatterCode"></el-table-column>
          <el-table-column
            :label="$t('권한 설명')"
            prop="authDesc"
            min-width="300"
            show-overflow-tooltip></el-table-column>
        </el-table>
      </el-col>
      <el-col :md="12">
        <el-card shadow="never" v-show="inputFormCard" :style="{ height: inputHeight + 'px' }" class="input-menu">
          <div slot="header">
            <span>{{ $t('권한') }}</span>
            <span v-if="'I' == inputForm.statu">{{ $t('추가') }}</span>
            <span v-if="'U' == inputForm.statu">{{ $t('수정') }}</span>

            <span v-if="selectData">{{ ` (${selectData.authNm})` }}</span>
          </div>
          <div>
            <el-form
              :model="inputForm"
              :label-width="$device.mobile ? `` : `120px`"
              label-suffix=":"
              :size="size"
              :disabled="fromDisabled"
              @submit.native.prevent>
              <el-form-item :label="$t('권한ID')" :error="formError.authId" required>
                <el-input
                  v-model="inputForm.authId"
                  maxlength="50"
                  show-word-limit
                  clearable
                  v-if="'I' === inputForm.statu"></el-input>
                <span v-else class="show_cd">{{ inputForm.authId }}</span>
              </el-form-item>
              <el-form-item :label="$t('권한명')" :error="formError.authNm" required>
                <el-input v-model="inputForm.authNm" maxlength="50" clearable show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('사용 가능 여부')" required>
                <combo :data="mainVue.code.useYn" :model="inputForm.useYn" @change="inputForm.useYn = $event"></combo>
              </el-form-item>
              <el-form-item :label="$t('권한 설명')" :error="formError.authDesc">
                <el-input v-model="inputForm.authDesc" type="textarea" maxlength="250" show-word-limit></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <el-card shadow="never" v-show="!inputFormCard">
          <div slot="header">
            <span>{{ $t('리소스 설정') }}</span>
            <span v-if="selectData">{{ ` (${selectData.authNm})` }}</span>
          </div>
          <el-tabs v-model="activeName">
            <el-tab-pane :label="$t('메뉴')" name="menu">
              <el-table
                :height="inputHeight - 100"
                border
                stripe
                highlight-current-row
                tooltip-effect="dark"
                ref="menuTable"
                :data="menuTableData"
                :size="size"
                :empty-text="$t('데이타 없음')"
                @select="menuHandleRowChecked"
                @select-all="menuHandleRowChecked"
                row-key="resourcesCd"
                :tree-props="{ children: 'subMenu' }"
                default-expand-all>
                <el-table-column type="selection" width="45" align="center"></el-table-column>
                <el-table-column :label="$t('코드')" prop="resourcesCd" width="100" align="left"></el-table-column>
                <el-table-column
                  :label="$t('메뉴명')"
                  prop="menuNmLan"
                  min-width="150"
                  show-overflow-tooltip></el-table-column>
                <el-table-column :label="$t('호출 타입')" prop="method" min-width="80" align="center"></el-table-column>
                <el-table-column
                  :label="$t('사용 가능 여부')"
                  prop="useYn"
                  min-width="110"
                  align="center"
                  :formatter="mainVue.formatterCode"></el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('이벤트')" name="action">
              <el-table
                :height="inputHeight - 100"
                border
                stripe
                highlight-current-row
                tooltip-effect="dark"
                ref="actionTable"
                :data="actionTableData"
                :size="size"
                :empty-text="$t('데이타 없음')"
                @select="actionHandleRowChecked"
                @select-all="actionHandleRowChecked">
                <el-table-column type="selection" width="45" align="center"></el-table-column>
                <el-table-column
                  :label="$t('아이디')"
                  prop="actionId"
                  width="120"
                  sortable
                  :fixed="!$device.mobile"
                  show-overflow-tooltip></el-table-column>
                <el-table-column
                  :label="$t('이벤트명')"
                  prop="actionNm"
                  min-width="150"
                  sortable
                  show-overflow-tooltip></el-table-column>
                <el-table-column :label="$t('타입')" prop="actionTp.nm" min-width="70" align="center"></el-table-column>
                <el-table-column
                  :label="$t('주소')"
                  prop="url"
                  min-width="150"
                  sortable
                  show-overflow-tooltip></el-table-column>
                <el-table-column :label="$t('호출 타입')" prop="method" min-width="100" sortable></el-table-column>
                <el-table-column
                  :label="$t('사용 가능 여부')"
                  prop="useYn"
                  min-width="110"
                  align="center"
                  :formatter="mainVue.formatterCode"></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { initData } from '@/utils/constants'
import mainVueMixin from '@/mixins/mainVueMixin'

/**
 * 상세 응답을 **화면 상태로** 만든다 — `resources` 는 언제나 배열이다.
 *
 * 서버는 외부 운영 주체(콜팝 등)에게 `GET /auth/{authId}` 를 `authId`·`authNm` 만으로 내린다.
 * 지금은 `/auth/*` GET 이 `admin` 에게만 열려 도달 경로가 없지만, 그 응답이 오면 리소스 맵을 펼치는
 * 자리가 TypeError 로 죽어 화면이 통째로 빈다. 「없다」와 「비었다」를 화면 안에서는 같게 본다.
 *
 * **인자를 건드리지 않는다** — 원본 응답은 [authBasicBody] 가 본문을 만들 때 다시 읽는다.
 *
 * @param {*} result 상세 응답
 * @param {string} statu 폼 모드(`'U'`)
 * @returns {object} 새 폼 객체
 */
function normalizeAuthDetail(result, statu) {
  const detail = result && typeof result === 'object' ? result : {}

  return Object.assign({}, detail, {
    statu: statu,
    resources: Array.isArray(detail.resources) ? detail.resources : [],
  })
}

/**
 * 기본 정보 카드의 저장 본문 — **비어 있는 리소스 맵은 싣지 않는다**.
 *
 * 이 카드가 고치는 것은 네 칸(ID·이름·사용·설명)이고 리소스를 보여 주지도 고치지도 않는다.
 * 그런데 폼은 상세 응답을 통째로 들고 있어 저장 때 `resources` 도 같이 나간다. 빈 배열은 서버에서
 * **「비움」**의 뜻이라, 상세가 좁게 왔거나([normalizeAuthDetail] 가 `[]` 를 채운 경우) 하는 순간
 * 사람이 본 적 없는 맵이 지워진다.
 *
 * 비어 있을 때 빼는 것은 두 경우 모두 안전하다: 정말 리소스가 없으면 빼나 넣으나 결과가 같고,
 * 화면이 못 본 맵이면 빼야 지켜진다. **값이 있을 때는 그대로 보낸다** — 전환 전과 같은 본문이다.
 * 리소스를 실제로 고르는 「리소스 설정」 카드의 저장은 이 함수를 지나지 않는다(빈 선택 = 비움이 맞다).
 *
 * @param {object} form 화면 폼
 * @returns {object} 요청에 실을 새 객체
 */
function authBasicBody(form) {
  const body = Object.assign({}, form)

  if (!Array.isArray(body.resources) || 0 === body.resources.length) delete body.resources

  return body
}

export default {
  mixins: [mainVueMixin],

  data: function () {
    var data = initData()
    data.url = '/auth'

    // 리소스 설정 부분
    data.btn.openAuthDisabled = true
    data.inputFormCard = true

    data.activeName = 'menu'
    data.menuTableData = []
    data.actionTableData = []
    data.menuResources = []
    data.actionResources = []

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    return data
  },
  created: function () {
    this.search()
    this.initResources()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    'inputForm.authId': function (newVal, oldVal) {
      if ('' != newVal && this.inputForm.statu == 'I') {
        this.chkAuthId()
      }
    },
    'inputForm.authNm': function (newVal, oldVal) {
      if ('' != newVal) {
        this.chkAuthNm()
      }
    },
  },
  methods: {
    // 선택된 메뉴/액션을 중복 없이 합치는 헬퍼
    combineSelectedResources(menuList, actionList) {
      const merged = []
      const seen = new Set()

      const pushIfNew = (item) => {
        if (!item || seen.has(item.resourcesCd)) return
        seen.add(item.resourcesCd)
        merged.push(item)
      }

      menuList.forEach(pushIfNew)
      actionList.forEach(pushIfNew)

      return merged
    },
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        authId: '',
        authNm: '',
        useYn: '',
      }
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        authId: '',
        authNm: '',
        authDesc: '',
        useYn: 'Y',
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        authId: '',
        authNm: '',
        authDesc: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
        this.btn.openAuthDisabled = false
      }
      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].authId
      }
    },
    // 추가
    add: function () {
      this.inputForm = this.initInputForm()
      this.formError = this.initFormError()

      this.btn.saveDisabled = false
      this.fromDisabled = false
      this.inputFormCard = true
    },
    // 수정
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.authId,
        function (result) {
          this.inputForm = normalizeAuthDetail(result, 'U')

          this.formError = this.initFormError()

          this.btn.saveDisabled = false
          this.fromDisabled = false
          this.inputFormCard = true
        }.bind(this),
        true
      )
    },
    /**
     * 조회 — 목록 행은 **네 칸**(`authId`·`authNm`·`authDesc`·`useYn`)이다.
     *
     * 종전에는 권한 11행에 리소스 맵 1,356행이 통째로 붙어 왔다(100KB+). 그 맵을 쓰는 곳은
     * 「리소스 설정」 하나뿐이고, 그 화면은 이미 [openAuth] 가 `GET /auth/{authId}` 로 다시 읽는다 —
     * 목록이 들고 오던 것은 **아무도 보지 않는 값**이었다.
     *
     * 그러니 **목록 행에서 `resources` 를 읽지 마라.** 필요한 곳은 [up] 과 [openAuth] 둘뿐이고
     * 둘 다 상세 GET 을 부른다. 행수가 적어 이 목록에는 페이징·서버 정렬이 없다(응답도 배열 그대로).
     */
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchForm,
        function (result) {
          this.tableData = result

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true
          this.btn.saveDisabled = true
          this.btn.openAuthDisabled = true
          this.fromDisabled = true
          this.inputFormCard = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        false
      )
    },
    // 삭제
    del: function () {
      this.mainVue
        .$confirm(this.$t('권한 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      if (this.inputFormCard) {
        if ('I' === this.inputForm.statu) {
          this.mainVue.$axios.add(
            this.url,
            this.inputForm,
            this.formError,
            function (result) {
              this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
              this.search()
            }.bind(this),
            true
          )
        } else {
          this.mainVue.$axios.up(
            this.url + '/' + this.inputForm.authId,
            authBasicBody(this.inputForm),
            this.formError,
            function (result) {
              this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
              this.search()
            }.bind(this),
            true
          )
        }
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.authId,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.search()
          }.bind(this),
          true
        )
      }
    },
    // 권한ID 체크
    chkAuthId: function () {
      this.mainVue.$axios.patchNonLoading(
        this.url + '/chk/' + this.inputForm.authId,
        null,
        null,
        function (result) {
          if ('' == result) {
            this.formError.authId = ''
            this.btn.saveDisabled = false
          } else {
            this.formError.authId = this.$t('이미 사용중인 권한ID입니다.')
            this.btn.saveDisabled = true
          }
        }.bind(this),
        false
      )
    },
    // 권한명 체크
    chkAuthNm: function () {
      this.mainVue.$axios.patchNonLoading(
        this.url + '/chkNm/' + this.inputForm.authNm,
        null,
        null,
        function (result) {
          if ('' == result || result.authId == this.inputForm.authId) {
            this.formError.authNm = ''
            this.btn.saveDisabled = false
          } else {
            this.formError.authNm = this.$t('이미 사용중인 권한명입니다.')
            this.btn.saveDisabled = true
          }
        }.bind(this),
        false
      )
    },
    // 메뉴, 이벤트 데이타 초기화
    initResources: function () {
      this.mainVue.$axios.search(
        '/menu',
        { menuNm: '', useYn: '' },
        function (result) {
          this.menuTableData = result
        }.bind(this),
        false
      )

      this.mainVue.$axios.search(
        '/action',
        { actionNm: '', useYn: '', actionTpCd: 0 },
        function (result) {
          this.actionTableData = result
        }.bind(this),
        false
      )
    },
    // 리소스 설정 팝업
    openAuth: function () {
      // 이전 선택 상태 초기화
      this.menuResources = []
      this.actionResources = []

      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.authId,
        function (result) {
          this.inputForm = normalizeAuthDetail(result, 'U')

          this.inputFormCard = false
          this.fromDisabled = true
          this.btn.saveDisabled = false
          this.activeName = 'menu'

          // 권한 가지고 있는 리소스 — 정규화를 지났으므로 언제나 배열이다
          var resCds = []

          for (var i = 0, len = this.inputForm.resources.length; i < len; i++) {
            resCds.push(this.inputForm.resources[i].resourcesCd)
          }

          this.$refs.menuTable.clearSelection()

          for (var i = 0, len = this.menuTableData.length; i < len; i++) {
            if (resCds.indexOf(this.menuTableData[i].resourcesCd) > -1) {
              this.$refs.menuTable.toggleRowSelection(this.menuTableData[i], true)
              this.menuResources.push(this.menuTableData[i])
            }

            for (var j = 0, jlen = this.menuTableData[i].subMenu.length; j < jlen; j++) {
              if (resCds.indexOf(this.menuTableData[i].subMenu[j].resourcesCd) > -1) {
                this.$refs.menuTable.toggleRowSelection(this.menuTableData[i].subMenu[j], true)
                this.menuResources.push(this.menuTableData[i].subMenu[j])
              }
            }
          }

          this.$refs.actionTable.clearSelection()

          for (var i = 0, len = this.actionTableData.length; i < len; i++) {
            if (resCds.indexOf(this.actionTableData[i].resourcesCd) > -1) {
              this.$refs.actionTable.toggleRowSelection(this.actionTableData[i], true)
              this.actionResources.push(this.actionTableData[i])
            }
          }

          // 중복 제거 후 inputForm.resources 최신화
          this.inputForm.resources = this.combineSelectedResources(this.menuResources, this.actionResources)
        }.bind(this),
        true
      )
    },
    // 메뉴, 이벤트 리스트 체크 이벤트
    menuHandleRowChecked: function (selection) {
      this.menuResources = selection
      this.inputForm.resources = this.combineSelectedResources(this.menuResources, this.actionResources)
    },
    // 메뉴, 이벤트 리스트 체크 이벤트
    actionHandleRowChecked: function (selection) {
      this.actionResources = selection
      this.inputForm.resources = this.combineSelectedResources(this.menuResources, this.actionResources)
    },
  },
}
</script>
